import _classCallCheck from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/tyson-foods/1598-sustainability-reporting/jamstack/Galileo-Salame/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from "react";
import SearchContext from "./SearchContext";
function buildContextForProps(context) {
  return Object.assign(Object.assign({}, context.driver.getState()), context.driver.getActions());
}
/* For a given object execute mapContextToProps to pluck out the relevant
properties */
function giveMeJustWhatINeeded(stateOrContext, mapContextToProps, props) {
  var mapContextToPropsToUse = props.mapContextToProps || mapContextToProps;
  return mapContextToPropsToUse(stateOrContext, props) || {};
}
function withSearch(mapContextToProps) {
  if (!mapContextToProps) {
    throw "withSearch requires a function to be provided which returns an object with at least one value.";
  }
  return function (Component) {
    var WithSearch = /*#__PURE__*/function (_React$PureComponent) {
      _inherits(WithSearch, _React$PureComponent);
      var _super = _createSuper(WithSearch);
      function WithSearch(props, context) {
        var _this;
        _classCallCheck(this, WithSearch);
        _this = _super.call(this, props);
        _this.subscription = function (state) {
          if (!_this.mounted) return;
          _this.setState(function (prevState) {
            return giveMeJustWhatINeeded(Object.assign(Object.assign({}, prevState), state), mapContextToProps, _this.props);
          });
        };
        _this.mounted = false;
        _this.state = Object.assign({}, giveMeJustWhatINeeded(buildContextForProps(context), mapContextToProps, props));
        return _this;
      }
      _createClass(WithSearch, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.mounted = true;
          // Note that we subscribe to changes at the component level, rather than
          // at the top level Provider, so that we are re-rendering the entire
          // subtree when state changes in the Provider.
          this.context.driver.subscribeToStateChanges(this.subscription);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.mounted = false;
          this.context.driver.unsubscribeToStateChanges(this.subscription);
        }
      }, {
        key: "render",
        value: function render() {
          var rest = __rest(this.props, []);
          return React.createElement(Component, Object.assign({}, this.state, rest));
        }
      }]);
      return WithSearch;
    }(React.PureComponent);
    WithSearch.contextType = SearchContext;
    return WithSearch;
  };
}
export default withSearch;